import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store/index'
import firebase from '@/firebase'
import VueAnalytics from 'vue-analytics'
import './registerServiceWorker'
import axios from '@/axios'
import Cookies from 'js-cookie'

Vue.config.productionTip = process.env.NODE_ENV !== 'production'

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: "UA-105803257-1",
    router
  })

  firebase.analytics()
}

Vue.prototype.$cookie = Cookies
Vue.prototype.$http = axios
Vue.prototype.$firebase = firebase

new Vue({
  firebase,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
